// extracted by mini-css-extract-plugin
export var chartArea = "dashboard-module--chartArea--w+G-A";
export var chartAreaItem = "dashboard-module--chartAreaItem--W0oOe";